<template>
  <section>
    <base-card>
      <h2>Page Not Found</h2>
      <p>
        This page could not be found - Back to
        <router-link to="/">home</router-link>
      </p>
    </base-card>
  </section>
</template>
